import { useEffect, useEffectEvent } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { sessionEnded } from '~/api/session';
import { bypassBlocker } from '~/constants/router';
import { SearchParamKeys } from '~/constants/url';
import { qs } from '~/utils/searchParams';

import { routes } from './router.routes';

/** Leave for the login screen when the session ends while the user is inside the protected area. */
export const SessionWatcher = () => {
  const navigate = useNavigate();
  const { hash, pathname, search } = useLocation();

  // Runs synchronously from the 401 handler, before React re-renders with the rejected query, so the
  // navigation is already under way by the time a suspense query would throw to an error boundary.
  const handleSessionEnded = useEffectEvent(() => {
    navigate(`${routes.login}${qs({ [SearchParamKeys.REDIRECT_PATH]: `${pathname}${search}${hash}` })}`, {
      replace: true,
      state: { ...bypassBlocker, isSessionExpired: true },
    });
  });

  useEffect(() => sessionEnded.subscribe(handleSessionEnded), []);

  return null;
};
